<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <!-- Summary -->
    <div class="row clearfix">
      <div class="col-12">
        <div class="card top_report card-top-line">
          <div class="row clearfix">
            <div
              class="col-lg-3 col-md-6 col-sm-6"
              v-for="(toprow, index) in transactions_toprows"
              :key="index"
            >
              <transactionstoprow-component
                :icon="toprow.icon"
                :text="toprow.text"
                :price="toprow.price"
              ></transactionstoprow-component>
              <!-- 
                                :progress_class = "toprow.progress_class"
                                :progressbar_width = "toprow.progressbar_width"
                                :compared_text = "toprow.compared_text"
                             -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header d-flex justify-content-between align-items-center">
            <h2>Fresh Customer List</h2>
          </div>
          <!-- Members Listing-->
          <div class="body pt-0">
            <!-- Filters/Buttons -->
            <div
              class="chart-top-action d-lg-flex justify-content-end py-3 fresh-customer-filter"
            >
              <!-- SearchBox Filters -->
              <div class="mr-0 mr-lg-3 action-top-search">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Keywords"
                    aria-label="Search"
                    v-model="search.keywords"
                    aria-describedby="search-transactions"
                    v-on:keyup.enter="refreshCustomerTable"
                  />
                  <div
                    class="input-group-append"
                    @click="refreshCustomerTable()"
                  >
                    <span class="input-group-text" id="search-mail">
                      <i class="icon-magnifier"></i>
                    </span>
                  </div>
                </div>
              </div>
              <!-- Toggle Filter Button -->
              <div class="fliter-main mr-auto mt-3 mt-lg-0">
                <b-button
                  class="fliter-btn btn-lg btn-mw"
                  :variant="isVisibleFilter ? 'primary' : 'outline-primary'"
                  @click="isVisibleFilter = !isVisibleFilter"
                >
                  Filter
                  <i class="fa fa-filter" aria-hidden="true"></i>
                </b-button>
              </div>
              <!-- Toggle Filter Collapse -->
              <b-collapse
                id="fliter-collapse"
                class="fliter-collapse"
                v-model="isVisibleFilter"
              >
                <div class="d-flex justify-content-between p-3">
                  <div class="form-group datepicker">
                    <b-input-group class="flex-nowrap">
                      <div class="input-group-prepend">
                        <span class="input-group-text">From</span>
                        <span
                          class="input-group-text"
                          @click="$refs.birthdate.showCalendar()"
                        >
                          <i class="icon-calendar"></i>
                        </span>
                      </div>
                      <datepicker
                        class="form-control"
                        ref="birthdate"
                        v-model="search.from"
                        :bootstrap-styling="false"
                        placeholder=""
                        :typeable="true"
                      ></datepicker>
                    </b-input-group>
                  </div>
                  <div class="form-group datepicker">
                    <b-input-group class="flex-nowrap">
                      <div class="input-group-prepend">
                        <span class="input-group-text">To</span>
                        <span
                          class="input-group-text"
                          @click="$refs.birthdate1.showCalendar()"
                        >
                          <i class="icon-calendar"></i>
                        </span>
                      </div>
                      <datepicker
                        class="form-control"
                        ref="birthdate1"
                        v-model="search.to"
                        :bootstrap-styling="false"
                        placeholder=""
                        :typeable="true"
                      ></datepicker>
                    </b-input-group>
                  </div>
                  <div class="form-group form-select single-multiselect">
                    <span class="float-label">
                      <multiselect
                        placeholder="Select Country"
                        v-model="search.country"
                        :show-labels="false"
                        :options="countryList"
                        label="name"
                        :searchable="true"
                      ></multiselect>
                    </span>
                    <div class="line"></div>
                  </div>
                  <div class="form-group">
                    <button
                      class="btn btn-primary h-100"
                      @click="
                        isVisibleFilter = true;
                        refreshCustomerTable();
                      "
                    >
                      Apply
                    </button>
                  </div>
                  <div class="form-group">
                    <button
                      class="btn btn-outline-danger h-100"
                      @click="
                        isVisibleFilter = false;
                        resetFilterValue();
                      "
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </b-collapse>
            </div>
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <!-- All Members List -->
            <b-table
              responsive
              ref="customerTable"
              table-class="mb-0 table-custom border"
              head-variant="light"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              striped
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #cell(accType)="data">
                <img
                  v-if="data.item.accType == 'Basic'"
                  width="20px"
                  :src="require(`@/assets/account-type-svg/plan-basic.svg`)"
                />
                <img
                  v-else-if="data.item.accType == 'GREY - Unvalidated Profiles'"
                  width="20px"
                  :src="require(`@/assets/account-type-svg/plan-grey.svg`)"
                />
                <img
                  v-else-if="data.item.accType == 'Silver'"
                  width="20px"
                  :src="require(`@/assets/account-type-svg/plan-silver.svg`)"
                />
                <img
                  v-else-if="data.item.accType == 'Silver+'"
                  width="20px"
                  :src="
                    require(`@/assets/account-type-svg/plan-silver-plus.svg`)
                  "
                />
                <img
                  v-else-if="data.item.accType == 'Bronze'"
                  width="20px"
                  :src="require(`@/assets/account-type-svg/plan-bronze.svg`)"
                />
                <img
                  v-else-if="data.item.accType == 'Red'"
                  width="20px"
                  :src="require(`@/assets/account-type-svg/plan-red.svg`)"
                />
                <span>{{ data.item.accType }}</span>
              </template>
              <template #cell(regdate)="data">
                <span>
                  {{ data.value.date }}
                  <br />
                  <small class="ml-2">{{ data.value.time }}</small>
                </span>
              </template>
              <template #cell(action)>
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  right
                  variant="outline-primary"
                >
                  <b-dropdown-item>Edit</b-dropdown-item>
                  <b-dropdown-item @click="showAlert">Delete</b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <main-loader :loading="isLoading"></main-loader>
  </div>
</template>
<script>
import "@/plugins/sweetalert2";
import "@/plugins/vee-validate";
import Multiselect from "vue-multiselect";
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
import { FRESH_CUSTOMER_LIST } from "../../../store/actions.type.js";
import { mapState, mapGetters } from "vuex";
export default {
  name: "FreshCustomerListComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    Datepicker: () => import("vuejs-datepicker"),
    Multiselect,
    "transactionstoprow-component": () =>
      import("@/components/core/TransactionsTopRow.vue"),
    "main-loader": LoaderComponent,
  },
  methods: {
    showAlert() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to delete this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success",
            );
          }
        });
    },

    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = this.currentPageJump = e.target.value;
        } else {
          this.currentPage = this.currentPageJump = paginationMenu;
        }
      } else {
        this.currentPage = this.currentPageJump = 1;
      }
    },
    getFreshCustomerList() {
      this.$store.dispatch(FRESH_CUSTOMER_LIST).then((response) => {
        console.log(response);
      });
    },
  },
  data() {
    return {
      items: [
        {
          regdate: { date: "2022-11-16", time: "06:50:59" },
          country: "Ghana",
          mobileNumber: "16102347489",
          accType: "Basic",
          action: "",
        },
        {
          regdate: { date: "1985-11-18", time: "06:50:59" },
          country: "Ghana",
          mobileNumber: "16102347557",
          accType: "GREY - Unvalidated Profiles",
          action: "",
        },
        {
          regdate: { date: "1991-11-22", time: "06:50:59" },
          country: "United Kingdom",
          mobileNumber: "14844493850",
          accType: "Silver",
          action: "",
        },
        {
          regdate: { date: "1993-11-22", time: "06:50:59" },
          country: "United Kingdom",
          mobileNumber: "15852135931",
          accType: "Silver+",
          action: "",
        },
        {
          regdate: { date: "1987-11-08", time: "06:50:59" },
          country: "Ghana",
          mobileNumber: "14844732134",
          accType: "Red",
          action: "",
        },
        {
          regdate: { date: "1989-11-08", time: "06:50:59" },
          country: "United States",
          mobileNumber: "14842989674",
          accType: "Bronze",
          action: "",
        },
      ],

      fields: [
        {
          key: "mobileNumber",
          label: "Mobile Number",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "country",
          label: "Country",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "regdate",
          label: "Regn. Date",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "accType",
          label: "Acc. Type",
          sortable: true,
          thClass: "th_sortfix",
        },
        { key: "action", label: "Action", thClass: "th_sortfix" },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],

      totalRows: 1,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 50,
      pageOptions: [50, 100, 150, { value: 1000, text: 1000 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      // newMemberUrl: window.location.origin+'/members-form/members-form.html',

      transactions_toprows: [
        {
          icon: "fa fa-user-plus",
          text: "New Customers(today)",
          price: "220",
          // progress_class:'bg-danger',
          // progressbar_width:'87',
          // compared_text:'1% compared to yesterday'
        },
        {
          icon: "fa fa-calendar",
          text: "New This Month",
          price: "100",
          // progress_class:'bg-success',
          // progressbar_width:'28',
          // compared_text:'19% compared to last month'
        },
        {
          icon: "fa-users",
          text: "Total Customers",
          price: "3200",
          // progress_class:'bg-info',
          // progressbar_width:'41',
          // compared_text:'19% compared to last year'
        },
        {
          icon: "fa fa-users",
          text: "Valid Customers",
          price: "3000",
          // progress_class:'bg-warning',
          // progressbar_width:'75',
          // compared_text:'19% compared to last year'
        },
      ],

      isVisibleFilter: false,

      search: {
        from: "",
        to: "",
        fname: "",
        mname: "",
        lname: "",
        rgroup: null,
        rstatus: null,
        country: null,
        keywords: "",
      },

      remiterOption: [
        { value: "Red", name: "Red" },
        { value: "Grey", name: "Grey" },
        { value: "Basic", name: "Basic" },
        { value: "Bronze", name: "Bronze" },
        { value: "Silver", name: "Silver" },
        { value: "Silver Plus", name: "Silver Plus" },
      ],
      remiterStatus: [
        { value: "N/A", name: "N/A" },
        { value: "Valid", name: "Valid" },
        { value: "Blocked", name: "Blocked" },
        { value: "Expired", name: "Expired" },
      ],
      refreshTable: false,
    };
  },
  mounted() {
    this.totalRows = this.items.length;
    this.getFreshCustomerList();
  },
  computed: {
    ...mapGetters(["isLoading", "countryList"]),
    ...mapState({
      apiErrors: (state) => state.auth.errors,
    }),
  },
};
</script>
